import { createSelector } from "@reduxjs/toolkit";
import { AdminSettings } from "../../types/state";
import { RootState } from "src/store/rootReducer";
import { NameSpace } from "../../const";

export const getSettingsVPO = createSelector(
  (state: RootState) => state.vpoStrapi[NameSpace.Settings],
  (state: AdminSettings) => state.data
);

export const getFetchingStatusSettings = createSelector(
  (state: RootState) => state.vpoStrapi[NameSpace.Settings],
  (state: AdminSettings) => state.fetchingStatusSettings
);
